import { render, staticRenderFns } from "./upload-new.vue?vue&type=template&id=3d0b18e2&scoped=true"
import script from "./upload-new.vue?vue&type=script&lang=js"
export * from "./upload-new.vue?vue&type=script&lang=js"
import style0 from "./upload-new.vue?vue&type=style&index=0&id=3d0b18e2&prod&lang=less&scoped=true"
import style1 from "./upload-new.vue?vue&type=style&index=1&id=3d0b18e2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0b18e2",
  null
  
)

export default component.exports